<template>
<div>
  <section v-if="!errorOccured">
  <transition name="fade">
    <!-- GIVE GOOGLE ACCESS -->
    <div v-if="!isGoogleAuthinticated" key="google-give-access">
      <v-btn
        color="success"
        :href="getGoogleAccessLink"
      >
        Give access to google sheets  <v-icon right>lock_open</v-icon>
      </v-btn>
    </div>
    <!-- GIVE GOOGLE ACCESS -->

    <!-- SETTINGS -->
    <div v-else-if="isGoogleAuthinticated && isContentReady" key="google-settings">
      <v-toolbar class="toolbar">
        <h1>Google Sheets export settings</h1>
        <v-spacer />
        <v-btn
          color="success"
          @click="onSaveSettings"
        >
          Save <v-icon dark right>save</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card
        v-for="settingKey in Object.keys(getGoogleSheetsSettings)"
        :key="settingKey"
        class="setting-card"
      >
        <div class="setting-card__head">
          <span><strong>{{ getCardTitle(settingKey) }}</strong></span>
        </div>
        <div class="setting-card__body">
          <div class="setting-card__col">
            <div>Is export enabled:</div>
            <div>
              <v-switch
                v-model="settings[settingKey].isEnabled"
              />
            </div>
          </div>
          <div class="setting-card__col">
            <div>File name:</div>
            <div>
              <content-field
                v-model="settings[settingKey].fileName"
                :error="$v.settings[settingKey].fileName"
              />
            </div>
          </div>
          <div class="setting-card__col">
            <div>Sheet name:</div>
            <div>
              <content-field
                v-model="settings[settingKey].sheetName"
                :error="$v.settings[settingKey].sheetName"
              />
            </div>
          </div>
        </div>
      </v-card>
      </div>
      <!-- SETTINGS -->
  </transition>
  </section>

  <!-- ERROR -->
  <section v-else-if="errorOccured || (!getSpinnerVisibilityStatus && !isContentReady)">
    <v-alert :value="true" type="error">
      Sorry, failed to load settings. Please, try later :(
    </v-alert>
  </section>
  <!-- ERROR -->
</div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { clone, path } from 'ramda'
  import { required } from 'vuelidate/lib/validators'

  export default {
    name: 'GoogleSheets',
    data () {
      return {
        settings: null,
        errorOccured: false
      }
    },
    validations () {
      return {
        settings: Object.keys(this.settings)
          .reduce((validations, settingKey) => {
            validations[settingKey] = {}
            const validator = this.settings[settingKey].isEnabled
              ? { required }
              : {}
            validations[settingKey].fileName = { ...validator }
            validations[settingKey].sheetName = { ...validator }
            return validations
          }, {})
      }
    },
    computed: {
      ...mapGetters([
        'getGoogleSheetsSettings',
        'isGoogleAuthinticated',
        'getGoogleAccessLink',
        'getSpinnerVisibilityStatus'
      ]),
      isContentReady () {
        return !!this.settings
      }
    },
    watch: {
      getGoogleSheetsSettings: {
        handler (settings) {
          this.initSettings(settings)
        },
        immediate: true
      }
    },
    methods: {
      ...mapActions([
        'updateGoogleSheetSettings',
        'fetchGoogleAuthCredentials',
        'fetchGoogleAuthLink',
        'googleAuthorize'
      ]),
      initSettings (settings) {
        this.settings = clone(settings)
      },
      onSaveSettings () {
        this.$v.settings.$touch()
        if (this.$v.settings.$invalid) return
        this.updateGoogleSheetSettings(this.settings)
      },
      getCardTitle (key) {
        const titlesMap = {
          attendeeToAttendee: 'Attendee to attendee messages',
          attendeeToSpeaker: 'Attendee to speaker messages',
          attendeeToBlitz: 'Attendee to blitz messages',
          agendaSessionQuestion: 'Agenda session questions',
          contactUs: 'Contact Us messages',
          attendeeToBlitzParticipant: 'Attendee to blitz participant messages'
        }

        return titlesMap[key]
      }
    },
    async created () {
      try {
        await this.fetchGoogleAuthCredentials()
        if (this.$route.query.code) {
          this.googleAuthorize(this.$route.query.code)
        }
      } catch (err) {
        this.errorOccured = true
        console.error(err)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .toolbar {
    margin-bottom: 20px;
  }

  .setting-card {
    padding: 10px;
    padding-bottom: 0;
    margin-bottom: 20px;

    &__head {
      margin-bottom: 15px;
    }

    &__body {
      display: flex;
      justify-content: space-between;
    }

    &__col {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 30%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/GoogleSheets/index.vue